import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { FitSummaryLabel } from "../../../constants";

function FitSummary({ fitCounts = {} }) {
  const isMobileViewport = useSelector(state => state.browser?.isMobileViewport);
  const fitSummaryBarWidth = isMobileViewport ? 200 : 170;

  const totalFitCount = Object.values(fitCounts).reduce((accumulator, currentValue) => {
    return accumulator + currentValue;
  }, 0);

  return (
    <table className="fit-summary" data-test-id="fit-summary">
      <tbody>
        {fitCounts &&
          Object.keys(FitSummaryLabel).map(function (key) {
            const label = FitSummaryLabel[key];
            const count = fitCounts[key];
            // fitSummaryBarWidth is the width of the bars
            const width = Math.floor((count / totalFitCount) * fitSummaryBarWidth);
            const displayLabel = `${label} (${count})`;
            return (
              <tr className="fit-summary__row" key={label}>
                {!isMobileViewport && <td className="fit-summary__label universal-small">{label}</td>}
                {/* temporary fix until we move migrate in mWeb and Desktop - will plan to change this to flex based system */}
                <td className="fit-summary__bar" style={{ width: fitSummaryBarWidth + 16 }}>
                  <div className="fit-summary__bar-background" style={{ width: fitSummaryBarWidth }}>
                    <div className="fit-summary__bar-highlight" style={{ width: width }} />
                  </div>
                </td>
                {isMobileViewport && <td className="fit-summary__label body-3-size">{displayLabel}</td>}
              </tr>
            );
          })}
      </tbody>
    </table>
  );
}

FitSummary.propTypes = {
  fitCounts: PropTypes.object.isRequired,
};

export default FitSummary;
